export enum Pickme {
  NAME = "Pickme",
}
